















import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import { VideoContainer, VideoAttributes } from '@/models/ResponsiveVideo';

@Component
export default class ResponsiveVideos extends Vue {
    videos: VideoContainer;

    autoplay: string;
    preload: string;
    loop: string;
    muted: string;
    controls: string;
    startTime: string;
    showAsPlayer: boolean;
    play: boolean = false;
    landscapeOrientation: boolean = true;
    elementSizeRatio: boolean = true;
    playStarted: boolean = false;
    orientationSet: boolean = false;
    mp4Src: string = '';
    webmSrc: string = '';

    constructor() {
        super();

        // @ts-ignore:
        this.videos = JSON.parse(this.$attrs['data-video']);

        this.autoplay = this.$attrs['data-video-autoplay'];
        this.preload = this.$attrs['data-video-preload'];
        this.loop = this.$attrs['data-video-loop'];
        this.muted = this.$attrs['data-video-muted'];
        this.controls = this.$attrs['data-video-controls'];

        this.showAsPlayer = false;
        if (typeof this.$attrs['data-video-show-player'] !== 'undefined') {
            this.showAsPlayer = this.$attrs['data-video-show-player'] === 'True' ? true : false;
        }
        this.startTime = '';
        if (typeof this.$attrs['data-video-start'] !== 'undefined' && this.showAsPlayer) {
            this.startTime = ('#t=' + this.$attrs['data-video-start']).replace(/,/g, '.');
        }

        if (this.showAsPlayer) {
            this.autoplay = 'false';
            this.muted = 'false';
        }
        if (!this.videos.BackgroundVideoMp4Portrait) {
            // If we are missing one of the portrait videos, we'll safe up by replacing portrait with landscape
            this.videos.BackgroundVideoMp4Portrait = this.videos.BackgroundVideoMp4Landscape;
            this.videos.BackgroundVideoWebmPortrait = this.videos.BackgroundVideoWebmLandscape;
        }

        this.$attrs['data-video'] = '';
    }

    mounted() {
        //this.setScreenOrientation();
        this.loadCorrectClip();
        const responsiveVideosElement = this.$refs['responsiveVideos'] as HTMLElement;
        let video;
        if (responsiveVideosElement && this.showAsPlayer) {
            video = responsiveVideosElement.querySelector('video') as HTMLVideoElement;
            video.addEventListener('play', e => {
                if (!this.playStarted) {
                    this.playStarted = true;
                }
            });
        }
    }

    private setAttributes() {
        const attributes: VideoAttributes = {};

        attributes.playsinline = 'playsinline';

        if (this.autoplay !== '' && this.autoplay !== undefined && this.autoplay !== 'false') {
            attributes['data-autoplay'] = this.autoplay;
            this.play = true;
        }

        if (this.preload !== '' && this.preload !== undefined && this.preload !== 'false') {
            attributes.preload = 'none'; //this.preload;
        }

        if (this.loop !== '' && this.loop !== undefined && this.loop !== 'false') {
            attributes.loop = this.loop;
        }

        if (this.muted !== '' && this.muted !== undefined && this.muted !== 'false') {
            attributes.muted = this.muted;
        }

        if (this.controls !== '' && this.controls !== undefined && this.controls !== 'false') {
            attributes.controls = this.controls;
        }

        return attributes;
    }

    private loadCorrectClip() {
        const isLandscape = window.outerWidth > window.outerHeight;
        if (isLandscape && this.videos.BackgroundVideoMp4Landscape && this.videos.BackgroundVideoWebmLandscape) {
            this.mp4Src = this.videos.BackgroundVideoMp4Landscape.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmLandscape.Url + this.startTime;
        } else if (!isLandscape && this.videos.BackgroundVideoMp4Portrait && this.videos.BackgroundVideoWebmPortrait) {
            this.mp4Src = this.videos.BackgroundVideoMp4Portrait.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmPortrait.Url + this.startTime;
        } else if (this.videos.BackgroundVideoMp4Landscape && this.videos.BackgroundVideoWebmLandscape) {
            this.mp4Src = this.videos.BackgroundVideoMp4Landscape.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmLandscape.Url + this.startTime;
        } else if (this.videos.BackgroundVideoMp4Portrait && this.videos.BackgroundVideoWebmPortrait) {
            this.mp4Src = this.videos.BackgroundVideoMp4Portrait.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmPortrait.Url + this.startTime;
        }
    }

    private togglePlay() {
        const responsiveVideosElement = this.$refs['responsiveVideos'] as HTMLElement;

        if (responsiveVideosElement !== null && responsiveVideosElement !== undefined) {
            const video = responsiveVideosElement.getElementsByTagName('video')[0];
            if (!this.playStarted)
                if (video != null && video !== undefined) {
                    if (this.play) {
                        // @ts-ignore:
                        video.pause();
                    } else {
                        if (this.showAsPlayer) {
                            video.currentTime = 0;
                            video.setAttribute('controls', 'controls');
                        }
                        // @ts-ignore:
                        video.play();
                    }
                    this.play = !this.play;
                }
        }
    }
}
